// // export default EmiDueReport;
// import React, { useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { Edit, Trash } from "lucide-react";
// import "../assets/GroupMember.css";

// const GroupMember = () => {
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [formData,setFormData]=useState({groupType:"",memberName:""});
//   const [memberData,setMemberData]=useState([])

//   // 🔍 Search + Pagination
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

// const handleChange = (e) => {
//   const { name, value } = e.target;

//   setFormData((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
// };

// const handleSubmit=(e)=>{
//   e.preventDefault();
//   setMemberData((prev) => [...prev, formData]);
//   // alert("Member Added")
//   //  console.log(memberData)
//   //  setFormData({groupType:"",memberName:""})
// }

//   // Static data
//   const staticData = [
//     {
//       groupType: "Group A",
//       groupName: "Group",
//     },
//   ];

//   // search and filter logic
//   const filteredData = useMemo(() => {
//     let data = [...memberData];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     return data;
//   }, [searchQuery,memberData]);

//   // pagination
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <div className="group-member-container">
//       <h1 className="group-member-heading">Group Member</h1>

//       {/* Group Member Creation section */}
//       <div className="group-member-create-container">
//         <h2>Create Group Member</h2>
//         <form className="group-member-create-form" onSubmit={handleSubmit}>
//           {/* <div className="group-member-create-form-groups"></div> */}
//           <select name="groupType" id="group-type" value={formData.groupType} onChange={handleChange}>
//             <option value="Select Group Type">Select Group Type</option>
//             <option value="Group A">Group A</option>
//             <option value="Group B">Group B</option>
//             <option value="Group C">Group C</option>
//           </select>
//           <input type="text" name="memberName" placeholder="Member Name" value={formData.memberName} onChange={handleChange} />
//           <button>Add</button>
//         </form>
//       </div>

//       {/* Group member report section */}
//       <div className="group-member-report-container">
//         <h2>Group Member Report</h2>
//         <div className="group-member-report-filter">
//           <input
//             type="text"
//             placeholder="Search by any field..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1);
//             }}
//           />

//           <label>
//             Show{" "}
//             <select
//               value={rowsPerPage}
//               onChange={(e) => {
//                 setRowsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value={100}>100</option>
//             </select>{" "}
//             entries
//           </label>
//         </div>

//         {/* Search input */}
//         {/* <div className="DDFDReportsearch-box">
//         <input
//           type="text"
//           placeholder="Search by any field..."
//           value={searchQuery}
//           onChange={(e) => {
//             setSearchQuery(e.target.value);
//             setCurrentPage(1);
//           }}
//         />
//       </div> */}

//         {/* Table */}
//         <div className="group-member-report-section">
//           <table className="group-member-report-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Group Type</th>
//                 <th>Member Name</th>
//                 {/* <th>Group Name</th>
//               <th>Description</th>
//               <th>DGT Start Date</th>
//               <th>CGT Taken By</th> */}
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((mdata, i) => (
//                   <tr key={i}>
//                     <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
//                     <td>{mdata.groupType}</td>
//                     <td>{mdata.memberName}</td>
//                     <td className="group-member-report-btns">
//                       <button
//                         className="group-member-report-edit-btn"
//                         // onClick={() => {
//                         //   setIsModalOpen(true);
//                         //   setSelectedCustomer(row);
//                         // }}
//                         title="Edit" // tooltip on hover
//                       >
//                         <Edit />
//                       </button>

//                       <button
//                         className="group-member-report-delete-btn"
//                         // onClick={() => openDeleteDialog(row.id)}
//                         title="Delete"
//                       >
//                         <Trash />
//                       </button>
//                     </td>
//                   </tr>
//                 ))): (
//             <tr>
//               <td
//                     colSpan="10"
//                     className="group-member-report-table-no-records"
//                   >
//                     ✅ No records found
//                   </td>
//             </tr>
//           )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Pagination */}
//       <div className="group-member-report-pagination-btns">
//         <button
//           onClick={() => setCurrentPage((p) => p - 1)}
//           disabled={currentPage === 1}
//         >
//           ⬅ Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPages || 1}
//         </span>

//         <button
//           onClick={() => setCurrentPage((p) => p + 1)}
//           disabled={currentPage === totalPages || totalPages === 0}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GroupMember;



import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";

import "../assets/GroupMember.css";
import { toast } from "react-toastify";

const GroupMember = () => {

  /* ---------------- STATES ---------------- */
  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [groupMember, setGroupMember] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];


    /* ================= FETCH Branch ================= */
    useEffect(() => {
      const fetchBranch = async () => {
        try {
          const res = await axios.get(`https://payyug.in/api/get-branch`, {
            params: {
              SuperAdminId: localStorage.getItem("adminuserId"),
              limit: "all",
            },
          });
          setBranchs(res?.data.branches || []);
        } catch (err) {
          console.error(err);
        }
      };
  
      fetchBranch();
    }, []);

  /* ---------------- FETCH CENTERS ---------------- */
  useEffect(() => {
    if (!selectedBranch?.id) return;

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`https://payyug.in/api/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ---------------- FETCH GROUPS ---------------- */
  useEffect(() => {
    if (!selectedCenter?.id) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`https://payyug.in/api/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId: selectedCenter.id,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ---------------- FETCH EMI ---------------- */
  const fetchGroupMember = async (page = 1) => {

    try {
      setLoading(true);

           const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(
        "https://payyug.in/api/group-loan/group/list",
        {
          params: {
            superAdminId,
          branchId: selectedBranch?.id,
          centerId: selectedCenter?.id,
          groupId: selectedGroup?.id,
            page,
            limit: itemsPerPage,
          },
          headers: { Authorization: `Bearer ${token}` },
        });
      console.log("group member", res.data);

      if (res.data?.success) {
        setGroupMember(res.data.data || []);
        setCurrentPage(res.data.currentPage||1);
        setTotalPages(res.data.totalPages||1);
        setTotalRecords(res.data.totalRecords||1);
      }
    } catch (error) {
      console.error("EMI fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  /* 🔁 search / per-page / page change */
  useEffect(() => {
    if (!selectedBranch||!selectedCenter || !selectedGroup) return;
    fetchGroupMember(currentPage);
  }, [currentPage, itemsPerPage]);


    const filteredData = groupMember.filter((g) => {
    const text = `
      ${g?.loanAmount}
      ${g?.memberName}
      ${g?.groupName}
      ${g?.officerName}
    `.toLowerCase();

    return text.includes(searchQuery.toLowerCase());
  });
  /* ---------------- FILTER SUBMIT ---------------- */
  const handleFilter = () => {
    if (!selectedBranch||!selectedCenter || !selectedGroup) {
      toast.warn("Please select center and group");
      return;
    }

    setCurrentPage(1);
    fetchGroupMember(1,itemsPerPage);
  };

    /* ================= ITEMS PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    setItemsPerPage(newLimit);
    setCurrentPage(1);

    if (selectedBranch && selectedCenter && selectedGroup) {
      fetchGroupMember(1, newLimit);
    }
  };
  /* ---------------- EXPORT ---------------- */
  const exportCSV = () => {
    const csv = groupMember
      .map((g) =>
        [
          g.groupName,
          g.memberName,
          g.loanAmount,
          g.officerName,
          g.status,
        ].join(","),
      )
      .join("\n");

    saveAs(new Blob([csv]), "group_member_report.csv");
  };

  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(groupMember);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Group Member Report");
    XLSX.writeFile(wb, "group_member_name.xlsx");
  };

  const exportPDF = () => {
    const doc = new jsPDF("l", "pt", "a4");
    autoTable(doc, {
      head: [["Group Name", "Member Name", "Loan Amount", "Officer Name", "Status"]],
      body: groupMember.map((g) => {
        return [
          g.groupName,
          g.memberName,
          g.loanAmount,
          g.officerName,
          g.status
        ];
      }),
    });
    doc.save("group_member_report.pdf");
  };

  return (
    <div className="gledr-container">
      <h1 className="gledr-heading">
        <i className="bi bi-file-earmark-text"></i> Group Member Report
      </h1>

      {/* FILTER */}
      <div className="gledr-filterBox">
        <div className="gledr-filter-title">Filter By</div>

        <div className="gledr-filter-wrapper">
          <div className="gledr-filter-item">
            <div className="gledr-filter">
              <label>Select Branch</label>
             <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value)
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                  setGroupMember([]);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const center = centers.find(
                    (cn) => cn.id === Number(e.target.value)
                  );
                  setSelectedCenter(center);
                  setSelectedGroup(null);
                  setGroupMember([]);
                }}
              >
                <option value="">Select Center</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
             <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedCenter}
                onChange={(e) => {
                  const group = groups.find(
                    (gr) => gr.id === Number(e.target.value)
                  );
                  setSelectedGroup(group);
                  setGroupMember([]);
                }}
              >
                <option value="">Select Group</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="gledr-filter-submit-btn">
            <button className="submit-btn" onClick={handleFilter}>
              submit
            </button>
          </div>
        </div>
      </div>

      {/* EXPORT */}
      {filteredData.length > 0 && (
        <div className="gledr-pdf-download-btns">
          <button onClick={exportCSV}>
            <Download size={15} /> CSV
          </button>
          <button onClick={exportExcel}>
            <Download size={15} /> Excel
          </button>
          <button onClick={exportPDF}>
            <Download size={15} /> PDF
          </button>
        </div>
      )}

      {/* 🔍 SEARCH + PER PAGE */}
      <div className="gledr-report-filter">
        <input
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <div className="gledr-report-filter-inputs">
         <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
        </div>
      </div>

      {/* TABLE */}
      <div className="gledr-report-table-container">
        <table className="gledr-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Group Name</th>
              <th>Member Name</th>
              <th>Loan Amount</th>
              <th>Officer Name</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" align="center">
                  Loading...
                </td>
              </tr>
            ) : filteredData.length ? (
              filteredData.map((g, i) => {
                return (
                  <tr key={g.id}>
                    <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                    <td>{g?.groupName}</td>
                    <td>{g?.memberName}</td>
                    <td>{g?.loanAmount}</td>
                    <td>{g?.officerName}</td>
                    <td className={""}>
                      {g?.status}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" align="center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="gledr-pagination">
        <button
          disabled={currentPage === 1 || filteredData.length === 0}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          ⬅ Prev
        </button>

        <span>
          {filteredData.length === 0
            ? "No data"
            : `Page ${currentPage} of ${totalPages}`}
        </span>

        <button
          disabled={currentPage === totalPages || filteredData.length === 0}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default GroupMember;

